import { render, staticRenderFns } from "./LmFormBuilderUi.vue?vue&type=template&id=6b7333d0&scoped=true&"
import script from "./LmFormBuilderUi.vue?vue&type=script&lang=js&"
export * from "./LmFormBuilderUi.vue?vue&type=script&lang=js&"
import style0 from "./LmFormBuilderUi.vue?vue&type=style&index=0&id=6b7333d0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7333d0",
  null
  
)

export default component.exports